import BreadCrump from '../tools/breadcrump';
import * as React from 'react';
import { useParams } from 'react-router-dom';
import { config } from "../../data/config";
import { useEffect } from 'react';
import { useCookies } from 'react-cookie';
import { useState } from "react";
import ImageUploader from '../tools/uploaderImage';
import axios from 'axios';
import { getCookies } from "cookies-next";
import Swal from 'sweetalert2';
import { useTranslation } from 'react-i18next';
import HeaderOfPage from '../tools/headerOfPage';
import Icons from '../../hoc/icons';

export default function SocialPage() {
    const Icon = new Icons();
    const { t } = useTranslation();

    const [data, setData] = React.useState<any>(null);
    const [key, setKey] = useState<any>(1);
    const [error, setError] = useState<any>(null);
    let cookie = getCookies();

    const inputstyle = "py-3  px-5 text-left block w-full border-gray-499 rounded text-sm focus:border-blue-500 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none shadow";
    const breadcrump = [
        {
            name: 'Dashboard',
            url: '/dashboard'
        },

        {
            name: 'Setting',
            url: '/dashboard/setting'
        },
        {
            name: 'Social Network',
            url: null
        },
    ]
    const load = async () => {
        try {
            var path = `${config.url}/v1/dashboard/socialnetwork`;

            let res = await axios({
                method: 'get',
                url: path,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            setData(res.data.message)
        } catch (error) {

        }
    }
    const save = async () => {
        try {
            var path = `${config.url}/v1/dashboard/socialnetwork/${data.id}`;

            let res = await axios({
                method: 'put',
                data: data,
                url: path,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            Swal.fire('Saved');
        } catch (error) {

        }
    }
    useEffect(() => {
        load();
    }, []);
    return (
        <div className='bg-slate-100'>
            <div className="text-left    p-3 m-4   min-h-[100vh] mb-5 ">


                <BreadCrump data={breadcrump}></BreadCrump>
                <HeaderOfPage name="Social Network"></HeaderOfPage>



                {
                    data != null && <div >
                        <div className=' w-[100%]  '>
                            <button
                                onClick={(e) => { save() }}
                                type="button" className=" w-[200px] gap-x-2 text-sm font-medium rounded-full border border-transparent bg-gray-700 text-white hover:bg-blue-700 focus:outline-none focus:bg-blue-700 disabled:opacity-50  text-center p-4 m-auto disabled:pointer-events-none">
                                {t('Save')}
                            </button>
                        </div>
                        <div className='' dir='ltr'>
                            <form key={key} className='grid grid-cols-1 sm:grid-cols-2 p-4' >

                                <div className="max-w-sm space-y-3">
                                    <label className="flex  items-center text-gray-700 font-bold gap-5"> <Icon.FaceBook ></Icon.FaceBook> FaceBook</label>
                                    <input
                                        defaultValue={data.facebook}
                                        type="text"
                                        className={`${inputstyle}  shadow    ${error != null && error['name'] != undefined && `bg-red-100`} `}
                                        placeholder="Full URL"
                                        onChange={(e) => setData({ ...data, facebook: e.target.value })}
                                    />
                                </div>
                                <div className="max-w-sm space-y-3">
                                    <label className="flex  items-center text-gray-700 font-bold gap-5"> <Icon.WhatsApp /> WhatsApp</label>
                                    <input
                                        defaultValue={data.whatsapp}
                                        type="text"
                                        className={`${inputstyle}  shadow    ${error != null && error['name'] != undefined && `bg-red-100`} `}
                                        placeholder="Full URL"
                                        onChange={(e) => setData({ ...data, whatsapp: e.target.value })}
                                    />
                                </div>
                                <div className="max-w-sm space-y-3">
                                    <label className="flex  pt-3  items-center text-gray-700 font-bold gap-5"> <Icon.YouTube /> Youtube</label>

                                    <input
                                        defaultValue={data.youtube}
                                        type="text"
                                        className={`${inputstyle}  shadow    ${error != null && error['name'] != undefined && `bg-red-100`} `}
                                        placeholder="Full URL"
                                        onChange={(e) => setData({ ...data, youtube: e.target.value })}
                                    />
                                </div>
                                <div className="max-w-sm space-y-3">
                                    <label className="flex pt-3  items-center text-gray-700 font-bold gap-5"> <Icon.Instagram /> Instagram</label>

                                    <input
                                        defaultValue={data.instagram}
                                        type="text"
                                        className={`${inputstyle}  shadow    ${error != null && error['name'] != undefined && `bg-red-100`} `}
                                        placeholder="Full URL"
                                        onChange={(e) => setData({ ...data, instagram: e.target.value })}
                                    />
                                </div>
                                <div className="max-w-sm space-y-3">
                                    <label className="flex pt-3  items-center text-gray-700 font-bold gap-5"> <Icon.Wechat /> WeChat</label>

                                    <input
                                        defaultValue={data.wechat}
                                        type="text"
                                        className={`${inputstyle}  shadow    ${error != null && error['name'] != undefined && `bg-red-100`} `}
                                        placeholder="Full URL"
                                        onChange={(e) => setData({ ...data, wechat: e.target.value })}
                                    />
                                </div>
                                <div className="max-w-sm space-y-3">
                                    <label className="flex pt-3  items-center text-gray-700 font-bold gap-5"> <Icon.Tiktok /> Tiktok</label>
                                    <input
                                        defaultValue={data.tiktok}
                                        type="text"
                                        className={`${inputstyle}  shadow    ${error != null && error['name'] != undefined && `bg-red-100`} `}
                                        placeholder="Full URL"
                                        onChange={(e) => setData({ ...data, tiktok: e.target.value })}
                                    />
                                </div>
                                <div className="max-w-sm space-y-3">
                                    <label className="flex pt-3  items-center text-gray-700 font-bold gap-5"> <Icon.Telegram /> Telegram</label>
                                    <input
                                        defaultValue={data.telegram}
                                        type="text"
                                        className={`${inputstyle}  shadow    ${error != null && error['name'] != undefined && `bg-red-100`} `}
                                        placeholder="Full URL"
                                        onChange={(e) => setData({ ...data, telegram: e.target.value })}
                                    />
                                </div>
                                <div className="max-w-sm space-y-3">
                                    <label className="flex pt-3  items-center text-gray-700 font-bold gap-5"> <Icon.TelegramChanal /> Telegram Chanal</label>

                                    <input
                                        defaultValue={data.telegramchanal}
                                        type="text"
                                        className={`${inputstyle}  shadow    ${error != null && error['name'] != undefined && `bg-red-100`} `}
                                        placeholder="Full URL"
                                        onChange={(e) => setData({ ...data, telegramchanal: e.target.value })}
                                    />
                                </div>

                                <div className="max-w-sm space-y-3">
                                    <label className="flex pt-3  items-center text-gray-700 font-bold gap-5"> <Icon.XTwitter /> X(twitter)</label>

                                    <input
                                        defaultValue={data.twitter}
                                        type="text"
                                        className={`${inputstyle}  shadow    ${error != null && error['name'] != undefined && `bg-red-100`} `}
                                        placeholder="Full URL"
                                        onChange={(e) => setData({ ...data, twitter: e.target.value })}
                                    />
                                </div>
                                <div className="max-w-sm space-y-3">
                                    <label className="flex pt-3  items-center text-gray-700 font-bold gap-5"> <Icon.Pinterest /> Pinterest  </label>

                                    <input
                                        defaultValue={data.pinterest}
                                        type="text"
                                        className={`${inputstyle}  shadow    ${error != null && error['name'] != undefined && `bg-red-100`} `}
                                        placeholder="Full URL"
                                        onChange={(e) => setData({ ...data, pinterest: e.target.value })}
                                    />
                                </div>
                                <div className="max-w-sm space-y-3">
                                    <label className="flex pt-3  items-center text-gray-700 font-bold gap-5">
                                        <Icon.Reddit />
                                        Reddit
                                    </label>

                                    <input
                                        defaultValue={data.reddit}
                                        type="text"
                                        className={`${inputstyle}  shadow    ${error != null && error['name'] != undefined && `bg-red-100`} `}
                                        placeholder="Full URL"
                                        onChange={(e) => setData({ ...data, reddit: e.target.value })}
                                    />
                                </div>
                                <div className="max-w-sm space-y-3">
                                    <label className="flex pt-3  items-center text-gray-700 font-bold gap-5">
                                        <Icon.Linkedin />
                                        Linkedin
                                    </label>
                                    <input
                                        defaultValue={data.linkedin}
                                        type="text"
                                        className={`${inputstyle}  shadow    ${error != null && error['name'] != undefined && `bg-red-100`} `}
                                        placeholder="Full URL"
                                        onChange={(e) => setData({ ...data, linkedin: e.target.value })}
                                    />
                                </div>
                                <div className="max-w-sm space-y-3">
                                    <label className="flex pt-3  items-center text-gray-700 font-bold gap-5">
                                        <Icon.Discord />
                                        Discord
                                    </label>
                                    <input
                                        defaultValue={data.discort}
                                        type="text"
                                        className={`${inputstyle}  shadow    ${error != null && error['name'] != undefined && `bg-red-100`} `}
                                        placeholder="Full URL"
                                        onChange={(e) => setData({ ...data, discort: e.target.value })}
                                    />
                                </div>
                                <div className="max-w-sm space-y-3">
                                    <label className="flex pt-3  items-center text-gray-700 font-bold gap-5">
                                        <Icon.Sapp />
                                        Sorosh
                                    </label>
                                    <input
                                        defaultValue={data.sorosh}
                                        type="text"
                                        className={`${inputstyle}  shadow    ${error != null && error['name'] != undefined && `bg-red-100`} `}
                                        placeholder="Full URL"
                                        onChange={(e) => setData({ ...data, sorosh: e.target.value })}
                                    />
                                </div>
                                <div className="max-w-sm space-y-3">
                                    <label className="flex pt-3  items-center text-gray-700 font-bold gap-5">
                                        <Icon.Rubika />
                                        Rubika
                                    </label>                                    <input
                                        defaultValue={data.rubika}
                                        type="text"
                                        className={`${inputstyle}  shadow    ${error != null && error['name'] != undefined && `bg-red-100`} `}
                                        placeholder="Full URL"
                                        onChange={(e) => setData({ ...data, rubika: e.target.value })}
                                    />
                                </div>
                                <div className="max-w-sm space-y-3">
                                    <label className="flex pt-3  items-center text-gray-700 font-bold gap-5">
                                        <img src='/icons/igap.png' width={20} />
                                        iGap
                                    </label>   
                                    <input
                                        defaultValue={data.rubika}
                                        type="text"
                                        className={`${inputstyle}  shadow    ${error != null && error['name'] != undefined && `bg-red-100`} `}
                                        placeholder="Full URL"
                                        onChange={(e) => setData({ ...data, igap: e.target.value })}
                                    />
                                </div>
                                <div className="max-w-sm space-y-3">
                                    <label className="flex pt-3  items-center text-gray-700 font-bold gap-5">
                                        <Icon.Eitaa />
                                        Eitaa
                                    </label>                                       <input
                                        defaultValue={data.eitaa}
                                        type="text"
                                        className={`${inputstyle}  shadow    ${error != null && error['name'] != undefined && `bg-red-100`} `}
                                        placeholder="Full URL"
                                        onChange={(e) => setData({ ...data, eitaa: e.target.value })}
                                    />
                                </div>


                            </form>

                        </div>



                    </div>
                }


            </div>

        </div>
    )
}